import { render, staticRenderFns } from "./smsManage.vue?vue&type=template&id=140df196&scoped=true"
import script from "./smsManage.vue?vue&type=script&lang=ts"
export * from "./smsManage.vue?vue&type=script&lang=ts"
import style0 from "./smsManage.vue?vue&type=style&index=0&id=140df196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140df196",
  null
  
)

export default component.exports